import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../layout/service/user.service';
import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TextareaModule } from 'primeng/textarea';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SocketService } from '../../layout/service/socket.service';
import { SheetUserAnswerDetail } from '../osce/sheet/sheet_user_answer_detail';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'app-start-simulations',
    standalone: true,
    imports: [
        TableModule,
        RadioButtonModule,
        TextareaModule,
        CommonModule,
        FormsModule,
        SheetUserAnswerDetail,
        DialogModule,
    ],
    styles: [`
        @media (max-width: 1024px) {
            .card.sticky {
                position: static !important;
                top: unset !important;
            }
        }
        @media (min-width: 1025px) {
            .card.sticky {
                top: 6rem !important;
            }
        }
        @media (max-width: 768px) {
            .p-table {
                font-size: 13px;
            }
            th, td {
                padding: 6px 4px !important;
            }
            textarea {
                font-size: 12px;
            }
            .osce-list {
                display: none !important;
            }
            .osce-list.show {
                display: block !important;
            }
        }
        @media (min-width: 1025px) {
            .osce-list {
                display: block !important;
            }
        }
        .p-table th, .p-table td {
            vertical-align: middle !important;
        }
        .timer-container {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 3px solid #2563eb;
            border-radius: 1.5rem;
            padding: 0.5rem 1rem;
            background: #f1f5fd;
            margin-bottom: 1rem;
            min-width: 100%;
            min-height: 60px;
            box-shadow: 0 4px 24px 0 rgba(31, 38, 135, 0.10);
        }
        .timer-container countdown {
            font-size: 1.8rem !important;
            font-weight: 700;
            color: #2563eb;
            letter-spacing: 0.1em;
        }
        .osce-list {
            margin-bottom: 1rem;
            background: #f8fafc;
            border-radius: 1rem;
            box-shadow: 0 2px 8px 0 rgba(31, 38, 135, 0.06);
            transition: box-shadow 0.2s, max-height 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.4s;
            overflow: hidden;
            max-height: 0;
            opacity: 0;
        }
        .osce-list.show {
            max-height: 600px;
            opacity: 1;
            box-shadow: 0 4px 16px 0 rgba(37, 99, 235, 0.13);
            animation: fadeInOsceList 0.4s cubic-bezier(0.4,0,0.2,1);
        }
        @keyframes fadeInOsceList {
            0% {
                opacity: 0;
                transform: translateY(-16px) scale(0.98);
            }
            100% {
                opacity: 1;
                transform: translateY(0) scale(1);
            }
        }
        .osce-list-title {
            font-size: 1.15rem;
            font-weight: 700;
            margin-bottom: 0.75rem;
            color: #2563eb;
            letter-spacing: 0.03em;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
        .osce-list-title::before {
            content: "📋";
            font-size: 1.2em;
        }
        .osce-items {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
        .osce-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.6rem 0.9rem;
            border-radius: 0.7rem;
            background: #e0e7ff;
            color: #1e293b;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            border: 2px solid transparent;
            box-shadow: 0 1px 4px 0 rgba(31, 38, 135, 0.04);
            transition: background 0.2s, color 0.2s, border 0.2s, box-shadow 0.2s;
            position: relative;
        }
        .osce-item.current {
            background: linear-gradient(90deg, #2563eb 70%, #60a5fa 100%);
            color: #fff;
            border: 2px solid #2563eb;
            font-weight: 700;
            box-shadow: 0 2px 8px 0 rgba(37, 99, 235, 0.12);
        }
        .osce-item.current::before {
            content: "★";
            color: #ffd700;
            margin-right: 0.5rem;
            font-size: 1.1em;
        }
        .osce-item:not(.current):hover {
            background: #c7d2fe;
            color: #1e293b;
            border: 2px solid #2563eb;
        }
        .osce-item .osce-kategori {
            font-size: 0.85em;
            color: #64748b;
            background: #f1f5f9;
            border-radius: 0.4em;
            padding: 0.1em 0.5em;
            margin-left: auto;
        }
        .toggle-osce-btn {
            display: inline-block;
            margin-bottom: 0.5rem;
            background: #2563eb;
            color: #fff;
            border: none;
            border-radius: 0.5rem;
            padding: 0.25rem 0.75rem;
            font-size: 0.95rem;
            cursor: pointer;
            transition: background 0.2s;
        }
        .toggle-osce-btn:hover {
            background: #1d4ed8;
        }
        @media (min-width: 1025px) {
            .toggle-osce-btn {
                display: none !important;
            }
        }
        /* Score display styles */
        .score-progress-bar {
            transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            animation: progressFill 0.6s ease-out;
        }
        .score-display {
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            border: 1px solid #bfdbfe;
            transition: all 0.3s ease;
        }
        .score-display.score-updated {
            animation: scoreUpdate 0.6s ease-out;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
        }
        @keyframes scoreUpdate {
            0% { 
                transform: scale(1); 
                box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
            }
            50% { 
                transform: scale(1.02); 
                box-shadow: 0 8px 20px rgba(37, 99, 235, 0.2);
            }
            100% { 
                transform: scale(1); 
                box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
            }
        }
        @keyframes progressFill {
            0% { 
                width: 0%; 
                opacity: 0.8;
            }
            100% { 
                opacity: 1;
            }
        }
        .score-number {
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
        }
        .score-grade-badge {
            animation: fadeInBounce 0.4s ease-out;
        }
        @keyframes fadeInBounce {
            0% { 
                opacity: 0; 
                transform: translateY(10px) scale(0.9); 
            }
            60% { 
                opacity: 1; 
                transform: translateY(-2px) scale(1.05); 
            }
            100% { 
                opacity: 1; 
                transform: translateY(0) scale(1); 
            }
        }
        .progress-container {
            background: rgba(0, 0, 0, 0.1);
            position: relative;
            overflow: hidden;
        }
        .progress-bar-animated {
            transition: width 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            position: relative;
        }
        .progress-bar-animated::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
            animation: shimmer 2s infinite;
        }
        @keyframes shimmer {
            0% { left: -100%; }
            100% { left: 100%; }
        }
        /* Hapus modal-backdrop dan modal-dialog jika ada */
    `],
    template: `
        <ng-container *ngIf="!showUserAnswerDetail">
            <div class="flex flex-col-reverse lg:flex-row gap-4 md:gap-8" *ngIf="!finished">
                <div class="w-full lg:w-5/7">
                    <div class="overflow-x-auto rounded-lg shadow bg-white p-2 md:p-4">
                        <p-table [value]="forms" showGridlines [loading]="loading"
                            [tableStyle]="{ 'min-width': '600px' }"
                            styleClass="mt-2 md:mt-5 min-w-full"
                            responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="text-center items-center bg-primary text-white" colspan="7">
                                        SKDI - {{ package[0]?.current_case?.SKDI || '-' }}
                                    </th>
                                </tr>
                                <tr>
                                    <th class="text-center" rowspan="2">No</th>
                                    <th rowspan="2">Kegiatan</th>
                                    <th colspan="4" class="text-center">Skor</th>
                                    <th class="text-center" rowspan="2">Komentar</th>
                                </tr>
                                <tr>
                                    <th class="text-center">0</th>
                                    <th class="text-center">1</th>
                                    <th class="text-center">2</th>
                                    <th class="text-center">3</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-form let-i="rowIndex">
                                <tr *ngIf="form.IS_HEADER === '1'">
                                    <td colspan="7" class="font-bold text-center bg-primary text-white" [innerHTML]="sanitizeHtml(form.ACTIVITY)"></td>
                                </tr>
                                <tr *ngIf="form.IS_HEADER === '0'">
                                    <td class="text-center align-middle py-2 px-1">
                                        {{
                                            getNonHeaderIndex(i) + 1
                                        }}
                                    </td>
                                    <td class="align-middle py-2 px-1" [innerHTML]="sanitizeHtml(form.ACTIVITY)"></td>
                                    <td class="text-center align-middle py-2 px-1">
                                        <label class="flex items-center justify-center cursor-pointer">
                                            <p-radiobutton [(ngModel)]="form.SKOR" name="score-{{ form.NO }}" value="0" 
                                                styleClass="w-6 h-6" (onClick)="onScoreChange(form, '0')" />
                                        </label>
                                    </td>
                                    <td class="text-center align-middle py-2 px-1">
                                        <label class="flex items-center justify-center cursor-pointer">
                                            <p-radiobutton [(ngModel)]="form.SKOR" name="score-{{ form.NO }}" value="1" 
                                                styleClass="w-6 h-6" (onClick)="onScoreChange(form, '1')" />
                                        </label>
                                    </td>
                                    <td class="text-center align-middle py-2 px-1">
                                        <label class="flex items-center justify-center cursor-pointer">
                                            <p-radiobutton [(ngModel)]="form.SKOR" name="score-{{ form.NO }}" value="2" 
                                                styleClass="w-6 h-6" (onClick)="onScoreChange(form, '2')" />
                                        </label>
                                    </td>
                                    <td class="text-center align-middle py-2 px-1">
                                        <label class="flex items-center justify-center cursor-pointer">
                                            <p-radiobutton [(ngModel)]="form.SKOR" name="score-{{ form.NO }}" value="3" 
                                                styleClass="w-6 h-6" (onClick)="onScoreChange(form, '3')" />
                                        </label>
                                    </td>
                                    <td class="align-middle py-2 px-1">
                                        <textarea rows="2" class="w-full min-w-[120px] md:min-w-[200px] rounded border p-1 text-xs md:text-sm"
                                            name="note-{{ form.NO }}" [(ngModel)]="form.NOTE" (ngModelChange)="onNoteChange()"
                                            placeholder="Tulis komentar..."></textarea>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    
                    <!-- Real-time Score Display - Moved above Jawaban Peserta -->
                    <div class="mt-6 mb-4 score-display rounded-xl p-4 shadow-sm"
                         [ngClass]="{'score-updated': scoreUpdated}">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-3">
                                <div class="w-10 h-10 rounded-full flex items-center justify-center"
                                     [ngClass]="{
                                         'bg-green-500': scoreColor === 'green',
                                         'bg-emerald-500': scoreColor === 'emerald',
                                         'bg-yellow-500': scoreColor === 'yellow',
                                         'bg-orange-500': scoreColor === 'orange',
                                         'bg-red-500': scoreColor === 'red',
                                         'bg-gray-500': scoreColor === 'gray'
                                     }">
                                    <span class="pi pi-chart-bar text-white font-bold"></span>
                                </div>
                                <div>
                                    <h3 class="text-lg font-bold mb-1"
                                        [ngClass]="{
                                            'text-green-900': scoreColor === 'green',
                                            'text-emerald-900': scoreColor === 'emerald',
                                            'text-yellow-900': scoreColor === 'yellow',
                                            'text-orange-900': scoreColor === 'orange',
                                            'text-red-900': scoreColor === 'red',
                                            'text-gray-700': scoreColor === 'gray'
                                        }">Skor Saat Ini</h3>
                                    <div class="score-grade-badge inline-block px-2 py-1 rounded-full text-xs font-bold"
                                         [ngClass]="{
                                             'bg-green-100 text-green-800': scoreColor === 'green',
                                             'bg-emerald-100 text-emerald-800': scoreColor === 'emerald',
                                             'bg-yellow-100 text-yellow-800': scoreColor === 'yellow',
                                             'bg-orange-100 text-orange-800': scoreColor === 'orange',
                                             'bg-red-100 text-red-800': scoreColor === 'red',
                                             'bg-gray-100 text-gray-700': scoreColor === 'gray'
                                         }">{{ scoreGrade }}</div>
                                </div>
                            </div>
                            <div class="text-right">
                                <div class="text-3xl font-black mb-1 score-number"
                                     [ngClass]="{
                                         'text-green-700': scoreColor === 'green',
                                         'text-emerald-700': scoreColor === 'emerald',
                                         'text-yellow-700': scoreColor === 'yellow',
                                         'text-orange-700': scoreColor === 'orange',
                                         'text-red-700': scoreColor === 'red',
                                         'text-gray-600': scoreColor === 'gray'
                                     }">
                                    {{ currentPercentage }}<span class="text-lg font-medium">/100</span>
                                </div>
                                <div class="text-sm font-medium"
                                     [ngClass]="{
                                         'text-green-600': scoreColor === 'green',
                                         'text-emerald-600': scoreColor === 'emerald',
                                         'text-yellow-600': scoreColor === 'yellow',
                                         'text-orange-600': scoreColor === 'orange',
                                         'text-red-600': scoreColor === 'red',
                                         'text-gray-500': scoreColor === 'gray'
                                     }">
                                    {{ currentScore }}/{{ maxPossibleScore }} poin
                                </div>
                            </div>
                        </div>
                        <!-- Progress Bar with improved animation -->
                    </div>
                    
                    <!-- Jawaban Peserta - dipindahkan ke bawah form -->
                    <div *ngIf="user && simulationId && package[0]?.current_case?.ID_OSCE" 
                         class="bg-blue-50 rounded-xl p-4 border border-blue-200">
                        <h3 class="text-lg font-bold text-blue-900 mb-3 flex items-center gap-2">
                            <span class="pi pi-user" style="font-size: 1.1em;"></span>
                            Jawaban Peserta: {{ user.name || '-' }}
                        </h3>
                        <app-sheet-user-answer-detail
                            [simulationId]="simulationId"
                            [osceId]="package[0]?.current_case?.ID_OSCE"
                            [sheetId]="getCurrentSheetId()"
                            [user]="user"
                            [currentOsceCase]="package[0]?.current_case"
                            [inline]="true"
                        ></app-sheet-user-answer-detail>
                        
                        <button (click)="saveParticipantAnswers()"
                            class="w-full mt-4 py-2.5 px-4 rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg border-0"
                            style="background:linear-gradient(90deg,#2563eb 60%,#60a5fa 100%); color:#fff; font-size:1.13rem; letter-spacing:0.01em; transition:background 0.2s,box-shadow 0.2s; box-shadow:0 4px 16px 0 rgba(37,99,235,0.13);"
                            onmouseover="this.style.background='linear-gradient(90deg,#1d4ed8 60%,#38bdf8 100%)'"
                            onmouseout="this.style.background='linear-gradient(90deg,#2563eb 60%,#60a5fa 100%)'"
                        >
                            <span class="pi pi-save" style="font-size:1.25em;"></span>
                            Simpan Jawaban Peserta
                        </button>
                    </div>
                </div>
                <div class="w-full lg:w-2/6">
                    <div class="card">
                        <div class="text-center">
                            <button class="toggle-osce-btn mb-2" (click)="toggleOsceList()">
                                {{ osceListVisible ? 'Sembunyikan OSCE' : 'Tampilkan OSCE' }}
                            </button>
                        </div>
                        <div class="osce-list" [class.show]="osceListVisible">
                            <div class="osce-items">
                                <div *ngFor="let osce of package[0]?.osce"
                                    class="osce-item"
                                    [ngClass]="{'current': osce.ID_OSCE === package[0]?.current_case?.ID_OSCE}"
                                    (click)="onOsceClick(osce)"
                                    style="cursor:pointer;">
                                    <span>{{ osce.TITLE }}</span>
                                    <span class="osce-kategori">{{ osce.KATEGORI }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- Card user aktif -->
                        <div *ngIf="user" class="card mt-3 mb-2 p-3 d-flex align-items-center justify-content-center" style="background:#e0f2fe; border-radius:1.2rem; box-shadow:0 4px 16px 0 rgba(37,99,235,0.10); max-width:340px; margin:auto;">
                            <div style="display:flex; align-items:center; gap:1.1rem;">
                                <div style="width:3.2rem; height:3.2rem; border-radius:50%; background:#2563eb; color:#fff; display:flex; align-items:center; justify-content:center; font-size:1.5rem; font-weight:700; box-shadow:0 2px 8px 0 rgba(31,38,135,0.13);">
                                    {{ user.name ? (user.name.split(' ').length > 1 ? (user.name.split(' ')[0][0] + user.name.split(' ')[1][0]) : user.name.substring(0,2)).toUpperCase() : (user.ID_USER || user.user_id || '?')[0] }}
                                </div>
                                <div>
                                    <div style="font-size:1.25rem; font-weight:800; color:#2563eb; line-height:1.1;">
                                        {{ user.name || '-' }}
                                    </div>
                                    <div style="font-size:0.98rem; color:#64748b; font-weight:500; margin-top:2px;">
                                        {{ user.ID_USER || user.user_id }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card text-center mt-4" *ngIf="finished">
                <div style="padding:2.5rem 1.5rem;">
                    <div style="font-size:2.8rem; color:#2563eb; margin-bottom:1.2rem;">
                        <span class="pi pi-check-circle" style="font-size:2.8rem; color:#22c55e;"></span>
                    </div>
                    <div style="font-size:2.2rem; font-weight:800; color:#2563eb; margin-bottom:0.7rem; letter-spacing:0.01em;">
                        Simulasi Selesai!
                    </div>
                    <div style="font-size:1.15rem; color:#64748b; margin-bottom:1.2rem;">
                        Berikut adalah ringkasan performa Anda:
                    </div>
                    <div style="background:linear-gradient(90deg,#22c55e 60%,#bbf7d0 100%); color:#fff; border-radius:1.2rem; padding:1.2rem 0.5rem; margin-bottom:1.5rem; box-shadow:0 2px 12px 0 rgba(34,197,94,0.10);">
                        <div style="font-size:1.1rem; font-weight:600; margin-bottom:0.3rem;">Nilai Rata-rata</div>
                        <div style="font-size:2.7rem; font-weight:900; letter-spacing:0.04em;">{{ averageScore }}<span style="font-size:1.2rem; font-weight:500;">/100</span></div>
                    </div>
                    <div style="font-size:1.15rem; color:#2563eb; font-weight:700; margin-bottom:0.7rem;">
                        Nilai per OSCE
                    </div>
                    <div style="display:flex; flex-direction:column; gap:0.7rem; align-items:center; margin-bottom:1.5rem;">
                        <div *ngFor="let osce of package[0]?.osce; let idx = index" style="background:#f1f5fd; border-radius:0.7rem; padding:0.7rem 1.5rem; min-width:220px; display:flex; justify-content:space-between; align-items:center;">
                            <span style="font-weight:500; color:#1e293b;">{{ osce.TITLE }}</span>
                            <span style="font-weight:700; color:#22c55e; font-size:1.2rem;">{{ osceScores[idx] || 0 }}/100</span>
                        </div>
                    </div>
                    <div style="font-size:1.1rem; color:#64748b; margin-bottom:2rem;">
                        {{ finishedMessage }}
                    </div>
                    <button class="toggle-osce-btn" style="background:#2563eb; color:#fff; font-size:1.1rem; padding:0.7rem 2.5rem; border-radius:0.8rem; font-weight:700; border:none; cursor:pointer; box-shadow:0 2px 8px 0 rgba(37,99,235,0.10);"
                        (click)="backToSimulation()">
                        Kembali ke Daftar Simulasi
                    </button>
                </div>
            </div>
        </ng-container>
        <p-dialog
            [(visible)]="showUserAnswerDetail"
            [modal]="true"
            [closable]="true"
            [dismissableMask]="true"
            [style]="{width: '900px', 'max-width': '98vw'}"
            [contentStyle]="{'padding':'0', 'background':'transparent'}"
            (onHide)="closeUserAnswerDetail()"
            [baseZIndex]="1000"
        >
            <app-sheet-user-answer-detail
                *ngIf="showUserAnswerDetail"
                [simulationId]="simulationId"
                [osceId]="osceId"
                [sheetId]="getCurrentSheetId()"
                [user]="user"
                [currentOsceCase]="package[0]?.current_case"
                (close)="closeUserAnswerDetail()"
            ></app-sheet-user-answer-detail>
        </p-dialog>
    `
})
export class StartSimulation implements OnInit, OnDestroy {
    code: string | null = null;
    package: any[] = [];
    forms: any[] = [];
    loading = true;
    osceListVisible = false;
    private socketSubscription: any;
    user: any = null;
    finished = false;
    osceScores: number[] = [];
    averageScore: number = 0;
    finishedMessage: string = '';
    showUserAnswerDetail = false;
    simulationId: any = null;
    osceId: any = null;
    submittedOsceIds: Set<string> = new Set();
    
    // New properties for sheet handling
    currentSheetIndex = 0;
    sheetCases: any[] = [];
    currentSheet: any = null;
    sheetTimer: any = null;
    
    // Properties for real-time score calculation
    currentScore: number = 0;
    maxPossibleScore: number = 0;
    currentPercentage: number = 0;
    scoreColor: string = 'gray';
    scoreGrade: string = 'Belum Dinilai';
    scoreUpdated: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private sanitizer: DomSanitizer,
        private socketService: SocketService
    ) {}

    ngOnInit(): void {
        this.code = this.route.snapshot.paramMap.get('code');
        
        // Check if there are sheet IDs in the URL parameters or path
        const sheetIdsParam = this.route.snapshot.paramMap.get('sheetIds');
        if (sheetIdsParam) {
            try {
                // Decode and parse the sheet IDs
                const decodedSheetIds = decodeURIComponent(sheetIdsParam);
                const parsedSheetIds = JSON.parse(decodedSheetIds);
                if (Array.isArray(parsedSheetIds)) {
                    // Initialize sheet cases with IDs from URL
                    this.sheetCases = parsedSheetIds.map(id => ({ id: String(id) }));
                    this.currentSheetIndex = 0;
                }
            } catch (error) {
            }
        }
        
        // Check if we're coming from a direct route with sheet IDs
        // This handles cases where sheet IDs are passed as a single parameter
        const currentUrl = this.router.url;
        
        // Extract sheet IDs from various possible URL patterns
        let extractedSheetIds: string[] = [];
        
        // Pattern 1: Direct sheet IDs in URL like /path/["7","6"]
        const urlEncodedMatch = currentUrl.match(/\[.*?\]/);
        if (urlEncodedMatch) {
            try {
                const sheetIdsStr = decodeURIComponent(urlEncodedMatch[0]);
                const parsedSheetIds = JSON.parse(sheetIdsStr);
                if (Array.isArray(parsedSheetIds)) {
                    extractedSheetIds = parsedSheetIds.map(id => String(id));
                }
            } catch (error) {
            }
        }
        
        // Pattern 2: Fragment-based sheet IDs (after #)
        const fragment = currentUrl.split('#')[1];
        if (fragment) {
            const fragmentMatch = fragment.match(/\[.*?\]/);
            if (fragmentMatch) {
                try {
                    const sheetIdsStr = decodeURIComponent(fragmentMatch[0]);
                    const parsedSheetIds = JSON.parse(sheetIdsStr);
                    if (Array.isArray(parsedSheetIds)) {
                        extractedSheetIds = parsedSheetIds.map(id => String(id));
                    }
                } catch (error) {
                }
            }
        }
        
        // If we found sheet IDs, initialize them
        if (extractedSheetIds.length > 0) {
            this.sheetCases = extractedSheetIds.map(id => ({ id: String(id) }));
            this.currentSheetIndex = 0;
        }
        
        // Ambil user_id dari query param jika ada
        this.route.queryParams.subscribe(params => {
            const userId = params['user_id'];
            const userName = params['name'];
            const simulationId = params['simulation_id'];
            this.simulationId = simulationId || null;
            if (userId) {
                // Ambil user dari daftar peserta di localStorage atau API jika perlu
                // Di sini diasumsikan user sudah ada di localStorage (array user)
                const usersRaw = localStorage.getItem('users');
                let userObj = null;
                if (usersRaw) {
                    try {
                        const users = JSON.parse(usersRaw);
                        if (Array.isArray(users)) {
                            userObj = users.find((u: any) => u.ID_USER == userId || u.user_id == userId);
                        }
                    } catch {}
                }
                // Jika tidak ditemukan di localStorage, fallback ke objek minimal
                this.user = userObj || { ID_USER: userId, user_id: userId };
                if (userName) {
                    this.user.name = userName;
                }
            } else {
                // Fallback: ambil dari localStorage jika tidak ada query param
                const user = localStorage.getItem('user');
                if (user) {
                    this.user = JSON.parse(user);
                }
            }
        });
        this.fetchPackage();
        this.osceListVisible = window.innerWidth >= 1024;
        const finished = localStorage.getItem('finished');
        this.finished = finished == 'true';
        
        // Initialize score calculation
        this.calculateCurrentScore();
        
        // Debug current state after initialization
        setTimeout(() => this.debugCurrentState(), 1000);
    }

    fetchPackage(): void {
        this.userService.getPackageSimulation().then((res) => {
            this.package = res.data || [];

            const val = (this.code + '').trim();
            const filtered = this.package.filter((form) => (form.code + '').trim() === val);

            this.package = filtered;

            this.package = this.package.map((form) => {
                let osceArr: any[] = [];
                try {
                    osceArr = JSON.parse(form.osce_id);
                    if (typeof osceArr === 'string') {
                        osceArr = JSON.parse(osceArr);
                    }
                } catch {
                    osceArr = [];
                }
                form.osce = osceArr;
                
                // Handle sheet_cases - prioritize URL sheets over package sheets
                if (this.sheetCases.length === 0) {
                    // Only process package sheets if no URL sheets were found
                    if (form.sheet_cases && Array.isArray(form.sheet_cases)) {
                        this.sheetCases = form.sheet_cases.map((sheet: any) => ({
                            id: String(sheet.id || sheet),
                            name: sheet.name || `Sheet ${sheet.id || sheet}`,
                            timer: sheet.timer || null
                        }));
                    } else if (form.sheet_case_id) {
                        // Fallback to parsing sheet_case_id if sheet_cases is not available
                        try {
                            let sheetIds = [];
                            if (typeof form.sheet_case_id === 'string') {
                                sheetIds = JSON.parse(form.sheet_case_id);
                            } else if (Array.isArray(form.sheet_case_id)) {
                                sheetIds = form.sheet_case_id;
                            }
                            
                            if (Array.isArray(sheetIds)) {
                                // Create sheet objects with just IDs - these will be populated when we fetch sheet details
                                this.sheetCases = sheetIds.map(id => ({ id: String(id) }));
                            }
                        } catch (error) {
                            this.sheetCases = [];
                        }
                    }
                }
                
                // Set current_case ke urutan pertama dari osce jika ada
                form.current_case = Array.isArray(form.osce) && form.osce.length > 0 ? form.osce[0] : null;
                return form;
            });

            if (this.package.length) {
                
                // Initialize sheet processing if we have sheets
                if (this.sheetCases.length > 0) {
                    this.currentSheetIndex = 0;
                    this.initializeCurrentSheet();
                } else {
                }
                
                // Only fetch form detail for the first time
                if (this.package[0].current_case?.ID_OSCE) {
                    this.getFormDetail(this.package[0].current_case.ID_OSCE);
                } else {
                }
                
                // Debug state after package processing
                setTimeout(() => this.debugCurrentState(), 500);
            }
        }).catch(() => {
            this.loading = false;
            this.router.navigate([`/app/osce/simulation`]);
        });
    }

    // Improved: prevent double submit and double fetch
    private lastSubmittedOsceId: string | null = null;
    private lastFetchedOsceId: string | null = null;

    // Sheet handling methods
    initializeCurrentSheet(): void {
        if (this.sheetCases.length > 0 && this.currentSheetIndex < this.sheetCases.length) {
            this.currentSheet = this.sheetCases[this.currentSheetIndex];

            
            
            // Ensure currentSheet has proper structure
            if (!this.currentSheet || !this.currentSheet.id) {
                return;
            }
            
            
            // Fetch sheet details if we only have ID
            if (this.currentSheet.id && !this.currentSheet.name) {
                this.fetchSheetDetails(this.currentSheet.id);
            }
            
            this.startSheetTimer();
        } else {
        }
    }

    fetchSheetDetails(sheetId: string): void {
        
        this.userService.getSheetCases(null).then((res: any) => {
            const sheets = res.data || [];
            const sheetDetail = sheets.find((s: any) => String(s.id) === String(sheetId));
            if (sheetDetail) {
                // Update current sheet with full details
                this.currentSheet = { ...this.currentSheet, ...sheetDetail };
                // Also update in the sheetCases array
                this.sheetCases[this.currentSheetIndex] = this.currentSheet;
            } else {
                // Set default name if not found
                this.currentSheet.name = `Sheet ${sheetId}`;
            }
        }).catch(error => {
            // Set default name if error occurred
            if (this.currentSheet) {
                this.currentSheet.name = `Sheet ${sheetId}`;
            }
        });
    }

    startSheetTimer(): void {
        if (this.currentSheet && this.currentSheet.timer) {
            const timerMinutes = parseInt(this.currentSheet.timer, 10);
            if (isNaN(timerMinutes) || timerMinutes <= 0) {
                return;
            }
            
            const timerMs = timerMinutes * 60 * 1000; // Convert to milliseconds
            
            
            // Clear any existing timer
            if (this.sheetTimer) {
                clearTimeout(this.sheetTimer);
                this.sheetTimer = null;
            }
            
            // Set timer for current sheet
            this.sheetTimer = setTimeout(() => {
                this.onSheetTimeUp();
            }, timerMs);
        } else {
        }
    }

    onSheetTimeUp(): void {
        
        // Save current sheet answers before moving to next
        this.saveCurrentSheetAnswers();
        
        // Move to next sheet
        this.currentSheetIndex++;
        
        if (this.currentSheetIndex < this.sheetCases.length) {
            // Initialize next sheet
            this.initializeCurrentSheet();
        } else {
            // All sheets completed
            this.onAllSheetsCompleted();
        }
    }

    // Save current sheet answers to localStorage
    saveCurrentSheetAnswers(): void {
        if (!this.currentSheet || !this.currentSheet.id) {
            return;
        }
        
        if (!this.package[0]?.current_case?.ID_OSCE) {
            return;
        }
        
        const currentOsceId = this.package[0].current_case.ID_OSCE;
        const currentSheetId = this.currentSheet.id;
        const answers = this.forms
            .filter(f => f.IS_HEADER === '0')
            .map(f => ({
                ID_DETAIL_OSCE: f.ID_DETAIL_OSCE,
                SKOR: f.SKOR,
                NOTE: f.NOTE
            }));
        
        // Save with both OSCE and sheet ID for better tracking
        const storageKey = `osce_score_${currentOsceId}_sheet_${currentSheetId}`;
        localStorage.setItem(storageKey, JSON.stringify(answers));
    }

    onAllSheetsCompleted(): void {
        this.finished = true;
        localStorage.setItem('finished', 'true');
        
        // Clean up timer
        if (this.sheetTimer) {
            clearTimeout(this.sheetTimer);
            this.sheetTimer = null;
        }
    }

    // Manual sheet switching (optional - for testing or manual control)
    switchToSheet(sheetIndex: number): void {
        if (sheetIndex >= 0 && sheetIndex < this.sheetCases.length) {
            // Save current sheet answers before switching
            this.saveCurrentSheetAnswers();
            
            // Clean up current timer
            if (this.sheetTimer) {
                clearTimeout(this.sheetTimer);
                this.sheetTimer = null;
            }
            
            this.currentSheetIndex = sheetIndex;
            this.initializeCurrentSheet();
            
        }
    }

    // Get current sheet display info
    getCurrentSheetInfo(): string {
        if (this.currentSheet) {
            return `${this.currentSheet.name || `Sheet ${this.currentSheet.id}`} (${this.currentSheetIndex + 1}/${this.sheetCases.length})`;
        }
        return 'No active sheet';
    }

    // Get current active sheet ID only
    getCurrentSheetId(): string | null {
        if (this.currentSheet && this.currentSheet.id) {
            // Ensure we return just the ID as string, not an array
            const sheetId = this.currentSheet.id;
            return typeof sheetId === 'string' ? sheetId : String(sheetId);
        }
        return null;
    }

    // Force move to next sheet (for manual control or external triggers)
    moveToNextSheet(): void {
        if (this.currentSheetIndex < this.sheetCases.length - 1) {
            this.onSheetTimeUp();
        } else {
            this.onAllSheetsCompleted();
        }
    }

    // Get current sheet progress info
    getSheetProgress(): { current: number; total: number; currentId: string | null } {
        return {
            current: this.currentSheetIndex + 1,
            total: this.sheetCases.length,
            currentId: this.getCurrentSheetId()
        };
    }

    async getFormDetail(id: string): Promise<void> {
        // Prevent unnecessary fetches
        if (this.lastFetchedOsceId === id) return;
        this.lastFetchedOsceId = id;
        this.loading = true;

        try {
            const response = await this.userService.getOsceDetail(
                { ID_OSCE: id }
            );
            const allForms = response.data?.FORM || [];
            // Pisahkan header dan non-header, urutkan non-header berdasarkan NO
            const headers = allForms.filter((f: any) => f.IS_HEADER === '1');
            const nonHeaders = allForms
                .filter((f: any) => f.IS_HEADER === '0')
                .sort((a: any, b: any) => {
                    // Pastikan NO adalah angka
                    const aNo = Number(a.NO);
                    const bNo = Number(b.NO);
                    return aNo - bNo;
                });
            // Gabungkan: header tetap di tempatnya, non-header diurutkan
            this.forms = [];
            let nonHeaderIdx = 0;
            for (let i = 0; i < allForms.length; i++) {
                if (allForms[i].IS_HEADER === '1') {
                    this.forms.push(allForms[i]);
                } else {
                    this.forms.push(nonHeaders[nonHeaderIdx++]);
                }
            }

            // Restore user answers from localStorage if available
            const userId = this.user?.ID_USER || this.user?.user_id;
            const currentSheetId = this.getCurrentSheetId();
            const storageKeyUser = currentSheetId
                ? `osce_score_${id}_sheet_${currentSheetId}_${userId}`
                : `osce_score_${id}_${userId}`;
            const savedAnswersRaw = localStorage.getItem(storageKeyUser) || localStorage.getItem(`osce_score_${id}`);
            if (savedAnswersRaw) {
                try {
                    const savedAnswers = JSON.parse(savedAnswersRaw);
                    for (const form of this.forms) {
                        if (form.IS_HEADER === '0') {
                            const saved = Array.isArray(savedAnswers)
                                ? savedAnswers.find((f: any) => f.ID_DETAIL_OSCE === form.ID_DETAIL_OSCE)
                                : null;
                            if (saved) {
                                form.SKOR = saved.SKOR !== undefined && saved.SKOR !== null ? String(saved.SKOR) : form.SKOR;
                                form.NOTE = saved.NOTE ?? saved.komentar ?? form.NOTE;
                            }
                        }
                    }
                } catch {}
            }

            // Fetch history from API database to ensure data is preserved across page navigations/refreshes
            await this.loadHistoryFromApi(id);

            // Only submit if not from socket and not already submitted for this OSCE
            if (this.shouldSubmitCurrentOsce() && this.lastSubmittedOsceId !== id) {
                this.lastSubmittedOsceId = id;
            }

        } catch (error) {
            this.forms = [];
        } finally {
            this.loading = false;
            // Calculate initial score after forms are loaded
            this.calculateCurrentScore();
        }
    }

    async loadHistoryFromApi(osceId: string): Promise<void> {
        const userId = this.user?.ID_USER || this.user?.user_id;
        const packageId = this.simulationId || this.package[0]?.id;

        if (!userId) return;

        try {
            const payload: any = { user_id: userId };
            if (packageId) {
                payload.package_id = packageId;
            }

            const res = await this.userService.simulationUserAnswer(payload);
            if (res && res.status && Array.isArray(res.data) && res.data.length > 0) {
                // Populate osceScores summary array for all OSCE items in package
                if (this.package && this.package[0] && Array.isArray(this.package[0].osce)) {
                    this.package[0].osce.forEach((osceItem: any, idx: number) => {
                        const rep = res.data.find((r: any) => String(r.ID_OSCE) === String(osceItem.ID_OSCE));
                        if (rep && rep.SKOR !== undefined && rep.SKOR !== null) {
                            this.osceScores[idx] = Number(rep.SKOR);
                        }
                    });
                }

                // Filter matching reports for the target OSCE ID (sorted DESC by CREATED_AT by backend)
                const matchingReports = res.data.filter((r: any) => String(r.ID_OSCE) === String(osceId));
                if (matchingReports.length > 0) {
                    const latestReport = matchingReports[0];
                    const reportId = latestReport.id || latestReport.ID || latestReport.ID_REPORT || latestReport.simulation_user_id;

                    if (reportId) {
                        const detailRes = await this.userService.getSimulationUserDetails({ ID_REPORT: reportId });
                        if (detailRes && detailRes.status && Array.isArray(detailRes.data)) {
                            const details = detailRes.data;
                            let updatedAny = false;
                            for (const form of this.forms) {
                                if (form.IS_HEADER === '0') {
                                    const match = details.find((d: any) => String(d.ID_OSCE_DETAIL) === String(form.ID_DETAIL_OSCE));
                                    if (match) {
                                        if (match.BOBOT !== undefined && match.BOBOT !== null) {
                                            form.SKOR = String(match.BOBOT);
                                        }
                                        if (match.KOMENTAR !== undefined && match.KOMENTAR !== null) {
                                            form.NOTE = match.KOMENTAR;
                                        }
                                        updatedAny = true;
                                    }
                                }
                            }
                            if (updatedAny) {
                                this.submittedOsceIds.add(osceId);
                                this.lastSubmittedOsceId = osceId;

                                // Sync loaded answers to localStorage cache
                                const answersToCache = this.forms
                                    .filter(f => f.IS_HEADER === '0')
                                    .map(f => ({
                                        ID_DETAIL_OSCE: f.ID_DETAIL_OSCE,
                                        SKOR: f.SKOR,
                                        NOTE: f.NOTE
                                    }));
                                const currentSheetId = this.getCurrentSheetId();
                                const storageKeyUser = currentSheetId
                                    ? `osce_score_${osceId}_sheet_${currentSheetId}_${userId}`
                                    : `osce_score_${osceId}_${userId}`;
                                localStorage.setItem(storageKeyUser, JSON.stringify(answersToCache));
                                localStorage.setItem(`osce_score_${osceId}`, JSON.stringify(answersToCache));
                            }
                        }
                    }
                }
            }
        } catch (err) {
            console.error('Failed to load simulation history from API:', err);
        }
    }

    shouldSubmitCurrentOsce(): boolean {
        const nonHeaderForms = this.forms.filter(f => f.IS_HEADER === '0');
        // Only submit if all SKOR are defined and at least one is not undefined
        return nonHeaderForms.length > 0 && nonHeaderForms.every(f => f.SKOR !== undefined && f.SKOR !== null);
    }

    private submittingOsceScore: boolean = false;

    submitCurrentOsceScore(): void {
        // Prevent double submit for the same OSCE or concurrent submits
        const currentOsceId = this.package[0]?.current_case?.ID_OSCE;
        if (
            !currentOsceId ||
            this.lastSubmittedOsceId === currentOsceId ||
            this.submittingOsceScore ||
            this.submittedOsceIds.has(currentOsceId)
        ) return;
        this.lastSubmittedOsceId = currentOsceId;
        this.submittingOsceScore = true;

        const nonHeaderForms = this.forms.filter(f => f.IS_HEADER === '0');
        const maxScore = nonHeaderForms.length * 3;
        let totalScore = 0;
        const details = nonHeaderForms.map(f => {
            const bobot = Number(f.SKOR) || 0;
            totalScore += bobot;
            return {
                osce_detail_id: f.ID_DETAIL_OSCE,
                bobot: bobot,
                komentar: f.NOTE || ''
            };
        });
        let skor = 0;
        if (maxScore > 0) {
            skor = Math.round((totalScore / maxScore) * 100);
            if (skor > 100) skor = 100;
        }
        // PHP backend treats 0 as empty via empty(), so ensure SKOR >= 1
        if (skor < 1) skor = 1;
        const currentIdx = this.package[0].osce.findIndex((o: any) => o.ID_OSCE === currentOsceId);
        if (this.osceScores.length <= currentIdx) {
            this.osceScores[currentIdx] = skor;
        }
        const userId = this.user?.ID_USER || this.user?.user_id;
        const loggedInUserStr = localStorage.getItem('user');
        let tutorName = 'Tutor';
        if (loggedInUserStr) {
            try {
                const loggedInUser = JSON.parse(loggedInUserStr);
                tutorName = loggedInUser.name || loggedInUser.user_fullname || loggedInUser.USERNAME || 'Tutor';
            } catch {}
        }

        this.userService.simulationAnswer({
            "ID_OSCE": currentOsceId,
            "KATEGORI": this.package[0].current_case.KATEGORI,
            "USER_ID": userId,
            "SIMULATION_ID": this.package[0].id,
            "SKOR": skor,
            "DETAILS": details
        }).then(() => {
            // Tandai OSCE ini sudah di-submit
            this.submittedOsceIds.add(currentOsceId);

            // Sync score & tutor name to the student's sheet_answer record
            const queryParams: any = {
                user_id: userId,
                osce_id: currentOsceId
            };
            if (this.simulationId) {
                queryParams.simulation_id = this.simulationId;
            }
            this.userService.getSheetAnswer(queryParams).then((res: any) => {
                if (res && res.status && res.data) {
                    let answers = Array.isArray(res.data) ? res.data : [res.data];
                    if (this.simulationId && answers.length > 1) {
                        answers = answers.filter((a: any) => String(a.simulation_id) === String(this.simulationId));
                    }
                    if (answers.length > 0) {
                        answers.sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                        const sheetAnswer = answers[0];
                        this.userService.updateSheetAnswer({
                            id: sheetAnswer.id,
                            score: skor,
                            penguji: tutorName
                        }).catch(err => console.error('Failed to update sheet answer:', err));
                    }
                }
            }).catch(err => console.error('Failed to fetch sheet answer for update:', err));
        }).finally(() => {
            this.submittingOsceScore = false;
        });
    }

    /**
     * Mendapatkan index urut non-header untuk penomoran tabel
     */
    getNonHeaderIndex(rowIndex: number): number {
        let count = 0;
        for (let idx = 0; idx <= rowIndex; idx++) {
            if (this.forms[idx]?.IS_HEADER === '0') {
                count++;
            }
        }
        return count - 1;
    }

    sanitizeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html || '');
    }

    /**
     * Menghitung skor real-time berdasarkan radiobutton yang dipilih
     */
    calculateCurrentScore(): void {
        const nonHeaderForms = this.forms.filter(f => f.IS_HEADER === '0');
        this.maxPossibleScore = nonHeaderForms.length * 3; // Maksimal 3 poin per item
        
        let totalScore = 0;
        nonHeaderForms.forEach(form => {
            const score = parseInt(form.SKOR) || 0;
            totalScore += score;
        });
        
        this.currentScore = totalScore;
        
        // Hitung persentase (0-100)
        if (this.maxPossibleScore > 0) {
            this.currentPercentage = Math.round((totalScore / this.maxPossibleScore) * 100);
        } else {
            this.currentPercentage = 0;
        }
        
        // Tentukan warna dan grade berdasarkan persentase
        if (this.currentPercentage >= 90) {
            this.scoreColor = 'green';
            this.scoreGrade = 'Sangat Baik';
        } else if (this.currentPercentage >= 80) {
            this.scoreColor = 'emerald';
            this.scoreGrade = 'Baik';
        } else if (this.currentPercentage >= 70) {
            this.scoreColor = 'yellow';
            this.scoreGrade = 'Cukup';
        } else if (this.currentPercentage >= 60) {
            this.scoreColor = 'orange';
            this.scoreGrade = 'Kurang';
        } else if (this.currentPercentage > 0) {
            this.scoreColor = 'red';
            this.scoreGrade = 'Perlu Perbaikan';
        } else {
            this.scoreColor = 'gray';
            this.scoreGrade = 'Belum Dinilai';
        }
    }

    /**
     * Event handler ketika radiobutton berubah
     */
    onScoreChange(form: any, value: string): void {
        const oldPercentage = this.currentPercentage;
        
        // Update form score
        form.SKOR = value;

        // Reset submission guard for current OSCE because score was changed
        const currentOsceId = this.package[0]?.current_case?.ID_OSCE;
        if (currentOsceId) {
            this.submittedOsceIds.delete(currentOsceId);
            if (this.lastSubmittedOsceId === currentOsceId) {
                this.lastSubmittedOsceId = null;
            }
        }
        
        // Recalculate score
        this.calculateCurrentScore();
        
        // Trigger animation only if score actually changed
        if (oldPercentage !== this.currentPercentage) {
            this.scoreUpdated = true;
            
            // Reset animation flag
            setTimeout(() => {
                this.scoreUpdated = false;
            }, 600);
        }
        
        // Force change detection for progress bar
        setTimeout(() => {
            // This ensures Angular detects the change
        }, 50);
    }

    onNoteChange(): void {
        const currentOsceId = this.package[0]?.current_case?.ID_OSCE;
        if (currentOsceId) {
            this.submittedOsceIds.delete(currentOsceId);
            if (this.lastSubmittedOsceId === currentOsceId) {
                this.lastSubmittedOsceId = null;
            }
        }
    }

    toggleOsceList() {
        this.osceListVisible = !this.osceListVisible;
    }

    onOsceClick(osce: any) {
        if (!osce || !osce.ID_OSCE) return;
        // Simpan jawaban OSCE saat ini ke localStorage sebelum pindah
        if (this.package[0]?.current_case?.ID_OSCE) {
            const currentId = this.package[0].current_case.ID_OSCE;
            const answers = this.forms
                .filter(f => f.IS_HEADER === '0')
                .map(f => ({
                    ID_DETAIL_OSCE: f.ID_DETAIL_OSCE,
                    SKOR: f.SKOR,
                    NOTE: f.NOTE
                }));
            localStorage.setItem(`osce_score_${currentId}`, JSON.stringify(answers));

            // Also submit to server if score is complete
            if (this.shouldSubmitCurrentOsce()) {
                this.submitCurrentOsceScore();
            }
        }
        this.package[0].current_case = osce;
        this.lastFetchedOsceId = null;
        this.getFormDetail(osce.ID_OSCE);
    }

    clearSimulationLocalStorage(): void {
        localStorage.removeItem('finished');
        localStorage.removeItem('isFinished');
        localStorage.removeItem('simulation_code');
        localStorage.removeItem('simulation_error');
        localStorage.removeItem('simulation_feedbackMsg');
        localStorage.removeItem('simulation_success');
        localStorage.removeItem('simulation_userName');
        
        // Remove all localStorage items starting with 'osce_score_'
        const keysToRemove: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith('osce_score_')) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(key => localStorage.removeItem(key));
    }

    ngOnDestroy(): void {
        if (this.socketSubscription && typeof this.socketSubscription.unsubscribe === 'function') {
            this.socketSubscription.unsubscribe();
        }
        
        // Clean up sheet timer
        if (this.sheetTimer) {
            clearTimeout(this.sheetTimer);
            this.sheetTimer = null;
        }

        // Clean up only the related simulation local storage items when leaving
        this.clearSimulationLocalStorage();
    }

    backToSimulation() {
        this.clearSimulationLocalStorage();
        this.router.navigate(['/app/osce/simulation']);
    }

    saveParticipantAnswers() {
        const userId = this.user?.ID_USER || this.user?.user_id;
        if (!userId) {
            alert('❌ Gagal menyimpan: Data pengguna tidak ditemukan. Silakan muat ulang halaman.');
            return;
        }
        
        const currentOsceId = this.package[0]?.current_case?.ID_OSCE;
        if (!currentOsceId) {
            alert('❌ Gagal menyimpan: Data OSCE tidak ditemukan.');
            return;
        }
        
        const currentSheetId = this.getCurrentSheetId();
        
        const answers = this.forms
            .filter(f => f.IS_HEADER === '0')
            .map(f => ({
                ID_DETAIL_OSCE: f.ID_DETAIL_OSCE,
                SKOR: f.SKOR,
                NOTE: f.NOTE
            }));
        
        // Save to localStorage with OSCE + optional sheet + user ID
        const storageKey = currentSheetId
            ? `osce_score_${currentOsceId}_sheet_${currentSheetId}_${userId}`
            : `osce_score_${currentOsceId}_${userId}`;
        localStorage.setItem(storageKey, JSON.stringify(answers));
        
        // Also save by OSCE ID only for backward compatibility
        localStorage.setItem(`osce_score_${currentOsceId}`, JSON.stringify(answers));
        
        // Reset submission guards so explicit save always works
        if (this.lastSubmittedOsceId === currentOsceId) {
            this.lastSubmittedOsceId = null;
        }
        this.submittedOsceIds.delete(currentOsceId);
        
        // Submit the score to server
        this.submitCurrentOsceScore();
        
        alert('✅ Jawaban berhasil disimpan!');
    }

    // Test method to simulate URL parsing
    testUrlParsing(): void {
        
        // Test different URL patterns
        const testUrls = [
            'http://localhost:4200/#/osce/sheet/answer/%5B%227%22,%226%22%5D',
            'http://localhost:4200/#/osce/sheet/answer/["7","6"]',
            '/osce/sheet/answer/["7","6"]'
        ];
        
        testUrls.forEach(url => {
            
            // Test pattern matching
            const urlEncodedMatch = url.match(/\[.*?\]/);
            if (urlEncodedMatch) {
                try {
                    const sheetIdsStr = decodeURIComponent(urlEncodedMatch[0]);
                    const parsedSheetIds = JSON.parse(sheetIdsStr);
                } catch (error) {
                }
            }
        });
    }

    // Test method to validate sheet processing
    testSheetProcessing(): void {
        
        // Simulate having sheet IDs
        const testSheetIds = ['7', '6'];
        this.sheetCases = testSheetIds.map(id => ({ id: String(id) }));
        this.currentSheetIndex = 0;
        
        
        // Initialize first sheet
        this.initializeCurrentSheet();
        
        // Test getting current sheet ID
        const currentId = this.getCurrentSheetId();
        
        // Test moving to next sheet
        setTimeout(() => {
            this.moveToNextSheet();
        }, 2000);
    }

    // Debug method to show current state
    debugCurrentState(): void {
    }

    closeUserAnswerDetail() {
        this.showUserAnswerDetail = false;
    }

    // Method to process and display selected sheet details
    processSheetDetails(participantAnswer: any): any[] {
        if (!participantAnswer || !participantAnswer.sheet_details) {
            return [];
        }

        // Parse sheet_detail_id to get selected IDs
        let selectedIds: string[] = [];
        try {
            if (typeof participantAnswer.sheet_detail_id === 'string') {
                selectedIds = JSON.parse(participantAnswer.sheet_detail_id);
            } else if (Array.isArray(participantAnswer.sheet_detail_id)) {
                selectedIds = participantAnswer.sheet_detail_id;
            }
        } catch (error) {
            return [];
        }

        // Filter sheet_details based on selected IDs
        const selectedDetails = participantAnswer.sheet_details.filter((detail: any) => 
            selectedIds.includes(String(detail.id))
        );

        return selectedDetails;
    }

    // Method to parse content array into table format
    parseSheetContent(content: string): string[] {
        try {
            if (typeof content === 'string') {
                return JSON.parse(content);
            }
            return Array.isArray(content) ? content : [];
        } catch (error) {
            return [];
        }
    }

    // Method to get interpretation text from pemeriksaan data
    getInterpretationText(participantAnswer: any, sheetName: string, header: string): string {
        if (!participantAnswer || !participantAnswer.pemeriksaan) {
            return '';
        }

        try {
            const pemeriksaan = typeof participantAnswer.pemeriksaan === 'string' 
                ? JSON.parse(participantAnswer.pemeriksaan) 
                : participantAnswer.pemeriksaan;

            const key = `${sheetName}||${header}`;
            return pemeriksaan[key] || '';
        } catch (error) {
            return '';
        }
    }

    // Method to format diagnosis data
    formatDiagnosis(participantAnswer: any): any {
        if (!participantAnswer || !participantAnswer.diagnosa) {
            return {
                diagnosaUtama: '',
                diagnosaBanding1: '',
                diagnosaBanding2: ''
            };
        }

        try {
            return typeof participantAnswer.diagnosa === 'string' 
                ? JSON.parse(participantAnswer.diagnosa) 
                : participantAnswer.diagnosa;
        } catch (error) {
            return {
                diagnosaUtama: '',
                diagnosaBanding1: '',
                diagnosaBanding2: ''
            };
        }
    }

    // Method to format prescription data
    formatPrescriptions(participantAnswer: any): string[] {
        if (!participantAnswer || !participantAnswer.resep) {
            return [];
        }

        try {
            return typeof participantAnswer.resep === 'string' 
                ? JSON.parse(participantAnswer.resep) 
                : participantAnswer.resep;
        } catch (error) {
            return [];
        }
    }
}
